import { BigNumber, providers } from 'ethers';
import { WalletProvider } from '../datas/walletProviders';
import {
  ChainExtended,
  ChainHtlc,
  ChainToken,
} from '../redux/slices/bridgeSlice';
import CoinHtlcService from '../services/coin-htlc.service';
import Erc20HtlcService from '../services/erc20-htlc.service';
import ERC20_ABI from '../abis/ethereum-erc20-kok-abi.json';
import HTLC_ERC20_ABI from '../abis/htlc-erc20-v2.abi.json';
import HTLC_COIN_ABI from '../abis/htlc-coin-v2.abi.json';
import { HtlcServiceInterface } from '../services/type';

const buildHtlcService = async (
  walletProvider?: WalletProvider | null,
  chain?: ChainExtended | null,
  chainToken?: ChainToken | null,
  chainHtlc?: ChainHtlc | null,
): Promise<HtlcServiceInterface> => {
  if (!walletProvider) {
    throw new Error(`WalletProvider is needed`);
  }
  if (!chain) {
    throw new Error(`Chain is not selected`);
  }
  if (!chainToken) {
    throw new Error(`ChainToken is needed`);
  }
  if (!chainHtlc) {
    throw new Error(`ChainHtlc is needed`);
  }

  let provider: providers.JsonRpcProvider | null = null;
  let signer: providers.JsonRpcSigner | null = null;

  if (walletProvider.symbol === `METAMASK`) {
    if (!window.ethereum) {
      console.error(`Refund : Error window.ethereum`);
      throw new Error(`Refund : window.ethereum`);
    }

    provider = new providers.Web3Provider(window.ethereum);

    signer = provider.getSigner();
  }

  if (!provider) {
    throw new Error(`Failed to load JsonRpcProvider`);
  }
  if (!signer) {
    throw new Error(`Failed to get JsonRpcSigner`);
  }

  // 체인 ID 확인
  const network = await provider.getNetwork();
  const selectedChainId = Number(BigNumber.from(network.chainId.toString()));
  const selectedEvmChainId = Number(
    BigNumber.from(chain.evmChainId.toString()),
  );
  // 지갑 체인이 선택된 from 체인과 다르면 Error 띄우기
  if (selectedChainId !== selectedEvmChainId) {
    throw new Error(`Invalid chain ID : ${Number(network.chainId)}`);
  }

  // ERC20
  if (chainToken.address) {
    return Erc20HtlcService.build(
      chainToken.address,
      chainHtlc.address,
      ERC20_ABI,
      HTLC_ERC20_ABI,
      signer,
    );
  }
  // Native
  return CoinHtlcService.build(chainHtlc.address, HTLC_COIN_ABI, signer);
};

export default buildHtlcService;
